<template>
  <div id="app">
      <keep-alive :include="['vehicleDetail']">
        <router-view/>
      </keep-alive>
  </div>
</template>
<script>

import commonUtils from '@/utils/common.js'

export default {
  name: 'App',
  data () {
    return {}
  },
  mounted () {
    // 20200922做可回溯判断
    this.getTraceBack()
  },
  methods: {
    //可回溯
    getTraceBack () {
      console.log('get trace back flag')
      try {
        let url = window.location.href
        if (url.indexOf('trace=1') > -1) {
          // 根据环境变量判断，如果是生产环境，则加载生产环境地址，否则加载sit地址
          let jsURl = ''
          if (process && process.env && process.env.ENV_CONFIG === 'prod') {
            jsURl = 'https://saletrace.zking.com/eye.js'
          } else {
            jsURl = 'https://test-saletrace.zking.com:20001/eye.js'
          }
          commonUtils.loadJs(jsURl)
        }
      } catch (e) {
      }
    },
  }
}
</script>
<style lang="scss">
html, body {
  /* 禁止用户选择文本 */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-text-size-adjust: 100% !important;
  /* 截断长单词 */
  // word-break:break-all;
  // -webkit-tap-highlight-color: red;
}
// #app{
//   width: 100%;
//   background-color: #000;
// }
// .container{
//   padding-right: 12px;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue